import axios from "axios";
import Qs from 'qs';

const Axios = axios.create({
  baseURL: "",
  timeout: 5000,//超时时间
  responseType: "json",
  withCredentials: true, // 是否允许带cookie这些
  headers: {
    "Content-Type": "application/x-www-form-urlencoded"
  }//请求头
})


//请求拦截器
Axios.interceptors.request.use(config => {
  return config;
}, error => {
  return Promise.reject(error);
});

//响应拦截器
Axios.interceptors.response.use(response => {
  const res = response;
  if (res.ErrorMsg !== '') {
    if(res.ResultMsg !== ''){
      Notification({
        title: '操作失败',
        message:res.ResultMsg + '\n'+ res.ErrorMsg || '未知错误！',
        type: 'error'
      });
    }else{
      Notification({
        title: '操作失败',
        message: res.ErrorMsg || '未知错误！',
        type: 'error'
      });
    }
    return Promise.reject(new Error(res.ErrorMsg || 'Error'))
  } else {
    return res
  }
}, error => {
  return Promise.reject(error);
});

export function httpGet(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
        params: params
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      })
  })
}

export function httpPost(url, params) {
  const httpUrl = 'http://202.104.158.140:5000' + url;
  return new Promise((resolve, reject) => {
    axios({
      url: httpUrl,
      method: 'post',
      data: Qs.stringify(params)
    }).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/request/httpUrl.js